import { Grid } from "@mui/material";
import AttachMoneyIcon from "@mui/icons-material/AttachMoney";
import ShoppingCartIcon from "@mui/icons-material/ShoppingCart";
import PersonIcon from "@mui/icons-material/Person";
import AssignmentReturnIcon from "@mui/icons-material/AssignmentReturn";
import { PortalStatCard } from "../../../../../components/PortalCard";
import { dashboardStore } from "../../../../../app/stores/Dashboard";
import { AnalyticsSummary } from "../../../../../services/analytics/AnalyticsService";
import moment from "moment";
import { useStoreConfig } from "../../../../../contexts/StoreConfigContext";

interface StatsTilesRowProps {
    analyticsSummary: AnalyticsSummary | null;
}

const StatsTilesRow = ({ analyticsSummary }: StatsTilesRowProps) => {
    const { avgOrderValue, totalOrders, totalSales } = dashboardStore(state => state);
    const { config } = useStoreConfig();

    // Format data for display
    const formatAvgOrderValue = () => {
        return avgOrderValue?.avg_order_value
            ? config.currency + avgOrderValue.avg_order_value.toFixed(2)
            : config.currency + "0.00";
    };

    const formatTotalSales = () => {
        return totalSales !== null
            ? config.currency + totalSales.toFixed(2)
            : config.currency + "0.00";
    };

    const formatTotalOrders = () => {
        return totalOrders?.total_orders?.toString() || "0";
    };

    const formatTotalVisitors = () => {
        return analyticsSummary?.uniqueVisitors?.toString() || "0";
    };

    return (
        <Grid container spacing={2} sx={{ mb: 2 }}>
            <Grid item xs={6} sm={6} md={3}>
                <PortalStatCard
                    icon={<AttachMoneyIcon />}
                    title='Total Sales'
                    value={formatTotalSales()}
                    iconBgColor='#3366FF'
                />
            </Grid>

            <Grid item xs={6} sm={6} md={3}>
                <PortalStatCard
                    icon={<ShoppingCartIcon />}
                    title='Avg Order Value'
                    value={formatAvgOrderValue()}
                    iconBgColor='#50B5FF'
                />
            </Grid>

            <Grid item xs={6} sm={6} md={3}>
                <PortalStatCard
                    icon={<PersonIcon />}
                    title='Total Visitors'
                    value={formatTotalVisitors()}
                    iconBgColor='#FF9066'
                />
            </Grid>

            <Grid item xs={6} sm={6} md={3}>
                <PortalStatCard
                    icon={<AssignmentReturnIcon />}
                    title={moment().format('MMMM') + ' Orders'}
                    value={formatTotalOrders()}
                    iconBgColor='#FF6B6B'
                />
            </Grid>
        </Grid>
    );
};

export default StatsTilesRow; 